import FilesListPage from './FilesListPage';

export default FilesListPage;
